export const email={label:"Email"};
export const SMS={label:"SMS"};
export const sendOTP={label:"Send OTP"};
export const login={label:"Login"};




export const canNotLogin="Can not login, please contact Headquarters.";
export const referenceNotFound="The reference number was not found!";
export const enterOTP="please enter your OTP";
export const after="Resend after ";
export const second="s";


export const trackStatus="Track Application Status";
export const enterReference="Enter Your Reference Number";
export const track="Track";
export const accreditedSuppliers="Accredited Suppliers";
export const softwareIntegrators="Software Integrators";
export const devices="Devices";
export const download="Download";
export const application="Application (Software)";
export const documents="Documents";
export const username ="Login ID";
export const enterUsername ="Please enter your account";
export const captcha ="Captcha";
export const enterCaptcha ="Please enter captcha";
export const pwd ="Password";
export const enterPwd ="Please enter your password";
export const OTPMethod ="OTP Delivery Method";
export const mobile ="Current mobile number";
export const forgetPwd ="Forgot your password?";
export const noAccount ="Don't have an account yet? ";
export const registerNow ="Register now";

export const note ="Note: Always keep your OTP in a safe and secure location.";
export const moreDetails ="More details";
export const prompt ="Prompt";
export const back ="Back";
export const howToProtect ="How to protect your OTP and business information.";

export const no1 ="i.Don't disclose your OTP over the phone or online.";
export const no2 ="ii.Never Disclose your OTP to anyone. even someone close to you.";
export const no3 ="iii.Don't carry your OTP on a piece of paper in your wallet, or pocket.";
export const no4 ="iv.Never write down your OTP where it can be seen by others.";
export const no5 ="v.Do not leave your computer or mobile Gadget unattended while logged-in.";
export const no6 ="vi.Guard your business and personal information.";
export const no7 ="vii.If you suspect that your OTP has been compromised, inform tax authority immediately. ";

export const modifyPassword ="Modify Password";
export const pleaseLogin ="Please login!";
export const downloadDocuments ="Download Documents";
export const forgetPassword ="Forgot Password";
export const newPassword ="New Password";
export const confirmPassword ="Confirm Password";
export const enterEmail = "Please enter your email.";
export const oldPassword="Old Password";
export const modifyPasswordCancel="Are you sure you want to cancel? Click ok, you will be logged out of the system.";
export const passwordSuccessfullyChangedPleaseReLogin="Password successfully changed! Please Re-login.";

export const no={label:"NO."};
export const softwareName={label:"Software Name"};
export const size={label:"Size"};
export const type={label:"Type"};
export const lastDate={label:"Update Date"};
export const downloadTimes={label:"Download Count"};
export const allName={label:"Operation"};

export const setting="Setting";
export const emailSetting = "Do you want to receive invoice notification as a buyer on your mail?";
export const taxCalculationSetting = "Which tax calculation method do you use?"

export const accountSecurity ="Account Security";
export const enableAuthorizeCode="Enable Authorized Login";
export const authorizeCode="Generate Authorization Code";
export const generate = "Generate";
export const generateTime = "Generate Time";
export const securityDescription="Click the 'Generate' button to regenerate the Authorization Code, and the Existing Authorization Code will automatically become invalid.";
